import { theme } from '@/utils/theme';

export const classes = {
  button: 'rounded-3xl px-6',
  caps: 'capitalize',
  nonCaps: 'normal-case',
  containedBackground: 'bg-grey-9 hover:bg-grey-9',
  containedText: 'text-white',
  border: 'border',
  outlinedBorder: 'border-grey-2 bg-white hover:bg-grey-2',
  outlinedText: 'text-grey-9',
  text: 'text-grey-8 hover:text-grey-9',
  disabled: 'not-allowed',
};

export const styles = {
  button: {
    border: '1px solid transparent',
    '&:focus': {
      border: `1px solid ${theme.palette['grey-2'].main}`,
    },
  },
};
